import request from '@/utils/request'

/**
 * 常见问题分类列表
 * POST /api/v1/admin/site_management/qa/category/list
 */
export function getFaqCategoryList(data) {
  return request({
    url: '/api/v1/admin/site_management/faq_type/list',
    method: 'post',
    mock: false,
    data,
  })
}

/**
 * 新增常见问题分类
 * POST /api/v1/admin/site_management/qa/category/add
 */
export function addFaqCategory(data) {
  return request({
    url: '/api/v1/admin/site_management/faq_type/add',
    method: 'post',
    mock: false,
    data,
  })
}

/**
 * 更新常见问题分类
 * POST /api/v1/admin/site_management/qa/category/update
 */
export function updateFaqCategory(data) {
  return request({
    url: '/api/v1/admin/site_management/faq_type/update',
    method: 'post',
    mock: false,
    data,
  })
}

/**
 * 删除常见问题分类
 * POST /api/v1/admin/site_management/qa/category/delete
 */
export function deleteFaqCategory(id) {
  return request({
    url: '/api/v1/admin/site_management/faq_type/delete',
    method: 'post',
    mock: false,
    data: { id },
  })
}

/**
 * 常见问题列表
 * POST /api/v1/admin/site_management/qa/question/list
 */
export function getFaqQuestionList(data) {
  return request({
    url: '/api/v1/admin/site_management/faq/list',
    method: 'post',
    mock: false,
    data,
  })
}

/**
 * 新增常见问题
 * POST /api/v1/admin/site_management/qa/question/add
 */
export function addFaqQuestion(data) {
  return request({
    url: '/api/v1/admin/site_management/faq/add',
    method: 'post',
    mock: false,
    data,
  })
}

/**
 * 更新常见问题
 * POST /api/v1/admin/site_management/qa/question/update
 */
export function updateFaqQuestion(data) {
  return request({
    url: '/api/v1/admin/site_management/faq/update',
    method: 'post',
    mock: false,
    data,
  })
}

/**
 * 删除常见问题
 * POST /api/v1/admin/site_management/qa/question/delete
 */
export function deleteFaqQuestion(id) {
  return request({
    url: '/api/v1/admin/site_management/faq/delete',
    method: 'post',
    mock: false,
    data: { id },
  })
}
